// extracted by mini-css-extract-plugin
export default {"body":"QueryHistoryWidget_body__Rlhdr","notFound":"QueryHistoryWidget_notFound__PUHL2","pagination":"QueryHistoryWidget_pagination__HPGl+"};